/* Nola — cuenta atrás visual del carrito (R62).
   · Empieza en 10:00 cuando el carrito pasa de vacío a tener artículos.
   · El plazo (epoch ms) vive en localStorage → no se reinicia al cerrar/abrir el drawer,
     navegar, recargar ni añadir más productos. Pertenece al carrito completo.
   · Al llegar a 00:00 se queda fijo en 00:00 (pulso breve una sola vez). NO toca el carrito:
     no vacía, no cambia cantidades, no hace ninguna llamada a /cart ni al checkout.
   · Si el carrito queda vacío se borra el plazo; el siguiente primer producto arranca otro. */
(function () {
  var KEY = 'nbCestaDeadline', DURATION = 10 * 60 * 1000, PULSE_MS = 3200;
  var wasRunning = false;
  var ls = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, String(v)); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };
  function count() {
    var el = document.querySelector('cart-drawer [data-nb-cesta-count]');
    return el ? parseInt(el.getAttribute('data-nb-cesta-count'), 10) || 0 : null;
  }
  function fmt(ms) {
    var s = Math.max(0, Math.ceil(ms / 1000)), m = Math.floor(s / 60), r = s % 60;
    return (m < 10 ? '0' : '') + m + ':' + (r < 10 ? '0' : '') + r;
  }
  function paint() {
    var d = parseInt(ls.get(KEY), 10);
    var txt = d ? fmt(d - Date.now()) : '10:00';
    document.querySelectorAll('[data-nb-cesta-clock]').forEach(function (el) { if (el.textContent !== txt) el.textContent = txt; });
  }
  function pulse() {
    document.querySelectorAll('[data-nb-cesta-clock]').forEach(function (el) {
      el.classList.add('is-ended');
      setTimeout(function () { el.classList.remove('is-ended'); }, PULSE_MS);
    });
  }
  /* Sincroniza el plazo con el estado real del carrito (leído del drawer ya renderizado). */
  function sync() {
    var n = count();
    if (n === null) return;
    if (n === 0) { ls.del(KEY); wasRunning = false; return; }
    if (!ls.get(KEY)) ls.set(KEY, Date.now() + DURATION);
    paint();
  }
  function tick() {
    var d = parseInt(ls.get(KEY), 10);
    if (!d) return;
    if (count() === 0) { ls.del(KEY); wasRunning = false; return; }
    var left = d - Date.now();
    paint();
    if (left > 0) { wasRunning = true; return; }
    if (wasRunning) { wasRunning = false; pulse(); }   // solo en el paso real por 00:00, no al recargar
  }
  function init() {
    ls.del('nbCestaCheckoutAt');   // resto de la lógica antigua de vaciado (ya no se usa)
    sync();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () { sync(); }).observe(drawer, { childList: true, subtree: true });
    }
    setInterval(tick, 500);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
